import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const JurnalPiket = ({ token }) => {
  const [jurnal, setJurnal] = useState([]);
  const [form, setForm] = useState({ kejadian: '', penanganan: '', penulis: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJurnal();
  }, []);

  const fetchJurnal = async () => {
    try {
      const res = await axios.get('https://sijapan.sman10fajarharapan.sch.id/api/jurnal', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setJurnal(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://sijapan.sman10fajarharapan.sch.id/api/jurnal', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      Swal.fire('Tersimpan', 'Jurnal berhasil dicatat', 'success');
      setForm({ kejadian: '', penanganan: '', penulis: '' });
      fetchJurnal();
    } catch (err) {
      Swal.fire('Gagal', 'Terjadi kesalahan', 'error');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Hapus catatan ini?")) {
        try {
            await axios.delete(`https://sijapan.sman10fajarharapan.sch.id/api/jurnal/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchJurnal();
        } catch (e) { alert('Gagal hapus'); }
    }
  };

  // Format Tanggal Indo
  const formatTanggal = (isoDate) => {
      return new Date(isoDate).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      <h2 style={{ color: '#1e293b', marginBottom: '20px' }}>📖 Jurnal Piket Harian</h2>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '30px' }}>
          
          {/* FORM INPUT */}
          <div style={{ background: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', height: 'fit-content' }}>
              <h4 style={{ margin: '0 0 20px', color: '#4361ee' }}>✍️ Catat Kejadian</h4>
              <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '15px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold' }}>Kejadian / Peristiwa</label>
                      <textarea 
                        required
                        rows="3"
                        placeholder="Contoh: Siswa sakit di UKS, Ada tamu dinas, dll."
                        value={form.kejadian}
                        onChange={e => setForm({...form, kejadian: e.target.value})}
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
                      ></textarea>
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold' }}>Tindakan / Penanganan</label>
                      <input 
                        type="text"
                        placeholder="Contoh: Diberi obat, Diizinkan pulang"
                        value={form.penanganan}
                        onChange={e => setForm({...form, penanganan: e.target.value})}
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
                      />
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold' }}>Petugas Piket (Penulis)</label>
                      <input 
                        required
                        type="text"
                        placeholder="Nama Guru Piket"
                        value={form.penulis}
                        onChange={e => setForm({...form, penulis: e.target.value})}
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1' }}
                      />
                  </div>
                  <button type="submit" style={{ width: '100%', padding: '12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
                      Simpan Catatan
                  </button>
              </form>
          </div>

          {/* LIST JURNAL */}
          <div>
              {loading ? <p>Memuat data...</p> : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                      {jurnal.length === 0 ? <p style={{ color: '#94a3b8', fontStyle: 'italic' }}>Belum ada catatan jurnal.</p> : 
                        jurnal.map((j) => (
                          <div key={j.id} style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', borderLeft: '5px solid #f59e0b', position: 'relative' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                  <span style={{ fontSize: '12px', background: '#fef3c7', padding: '3px 8px', borderRadius: '4px', color: '#b45309', fontWeight: 'bold' }}>
                                      📅 {formatTanggal(j.tanggal)} • ⏰ {j.jam.slice(0,5)}
                                  </span>
                                  <button onClick={() => handleDelete(j.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '16px' }}>🗑️</button>
                              </div>
                              <h3 style={{ margin: '0 0 5px', fontSize: '16px', color: '#1e293b' }}>{j.kejadian}</h3>
                              <p style={{ margin: '0 0 10px', fontSize: '14px', color: '#64748b' }}>➡ Penanganan: {j.penanganan || '-'}</p>
                              <div style={{ fontSize: '12px', color: '#94a3b8', borderTop: '1px dashed #e2e8f0', paddingTop: '8px' }}>
                                  ✍️ Ditulis oleh: <b>{j.penulis}</b>
                              </div>
                          </div>
                        ))
                      }
                  </div>
              )}
          </div>

      </div>
    </div>
  );
};

export default JurnalPiket;